import { useState } from 'react';

const faqItems = [
  {
    question: 'What is Sugargoo Spreadsheet?',
    answer: 'Sugargoo Spreadsheet is a structured resource system that helps shoppers discover products, organize finds and compare different options before purchasing. Instead of searching thousands of products manually, users can explore categorized spreadsheets including sneakers, clothing, streetwear, accessories, electronics, and fashion items curated by experienced community members.',
  },
  {
    question: 'How does Sugargoo Spreadsheet work?',
    answer: 'Community members discover products through various channels and organize them into spreadsheet databases categorized by product type. Each entry includes product name, direct purchase link, price range, available sizes and colors, quality ratings, and real buyer photos. This collaborative system makes product discovery significantly faster and more reliable than individual searching.',
  },
  {
    question: 'Is Sugargoo legit and safe to use?',
    answer: 'Sugargoo is a legitimate shopping agent service used by millions of international buyers. However, as with any online shopping platform, we recommend verifying seller information, protecting your payment details, understanding shipping policies, and avoiding suspicious links. The Sugargoo Spreadsheet community helps by providing verified product recommendations and honest reviews from real buyers.',
  },
  {
    question: 'How much does Sugargoo shipping cost?',
    answer: 'Sugargoo shipping costs vary based on package weight, destination country, and shipping method selected. International shipping options typically range from economy lines for budget-conscious shoppers to express courier services for faster delivery. We recommend using the Sugargoo shipping calculator on their platform to get accurate estimates for your specific order.',
  },
  {
    question: 'Where is the Sugargoo warehouse located?',
    answer: 'Sugargoo operates warehouses in China where purchased items are received, inspected, and stored before international shipping. The warehouse team performs quality checks, takes inspection photos, and consolidates multiple orders into single shipments to help buyers save on international shipping costs.',
  },
  {
    question: 'How can I find the best Sugargoo Spreadsheet discounts?',
    answer: 'The Sugargoo platform periodically offers coupons, discount codes, and promotional events for both new and returning users. Check the official Sugargoo website for current promotions, subscribe to their newsletter for exclusive deals, and follow the community forums where members often share the latest discount codes and saving strategies.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Frequently Asked Questions About Sugargoo Spreadsheet
          </h2>
          <p className="text-sm text-foreground-600">
            Everything you need to know about using Sugargoo spreadsheet resources for smarter shopping
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div
                  className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-foreground-500`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-xs text-foreground-500 mb-3">
            Still have questions? Visit our main platform for more information and resources.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Visit Sugargoo Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}